import { Tooltip } from "@mui/material";

const statusMap = new Map([[1, 'background-success'], [2, 'background-warning'], [3, 'background-danger'], [4, 'background-inactive']])

const CorpCalendarTestResult = ({
  title,
  status,
  complianceInterval
}: {
  title: string;
  status: number;
  complianceInterval: string;
}) => {
  const className = `test-result ${complianceInterval} ${statusMap.get(Number(status))}`;
  return (
    <Tooltip
      title={title}
      className={className}
      placement="top"
      disableInteractive
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: { offset: [0, -8] }
            }
          ]
        }
      }}
    >
      <div className={className}></div>
    </Tooltip>
  )
};

export default CorpCalendarTestResult;